import React from 'react';
const defaultContext = {
  noPadding: undefined
};
export const CardContext = /*#__PURE__*/React.createContext(defaultContext);
export const useCardContext = () => React.useContext(CardContext);